import * as React from "react";

function EnvelopeOpenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M493.6 163c-24.88-19.62-45.5-35.37-164.3-121.6C312.7 29.21 279.7 0 256.4 0h-.8c-23.3 0-56.3 29.21-73 41.38C63.88 127.6 43.25 143.4 18.38 163 6.75 172 0 186 0 200.8V448c0 35.3 28.65 64 64 64h384c35.35 0 64-28.67 64-64.01V200.8c0-14.8-6.7-28.8-18.4-37.8zM464 448c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V276.7l136.1 113.4c20.2 16.7 45.7 25.9 71.9 25.9s51.75-9.211 71.97-26.01L464 276.7V448zm0-233.8L297.2 352.3c-23.19 19.28-59.34 19.27-82.47.016L48 214.2l.105-13.48c23.24-18.33 42.25-32.97 162.9-120.6 3.083-2.254 6.675-5.027 10.63-8.094C229.4 65.99 246.7 52.59 256 48.62c9.312 3.973 26.62 17.37 34.41 23.41 3.959 3.066 7.553 5.84 10.76 8.186C421.6 167.7 440.7 182.4 464 200.8v13.4z"
  }));
}

const ForwardRef = React.forwardRef(EnvelopeOpenIcon);
export default ForwardRef;